export default {
  PAY_NOW: Symbol('PAY_NOW'),
  PAY_LATER: Symbol('PAY_LATER'),
  CREDIT_DEBIT_CARD: Symbol('CREDIT_DEBIT_CARD'),
  BUY_NOW_PAY_LATER: Symbol('BUY_NOW_PAY_LATER'),
  OTHER_PAYMENT_METHODS: Symbol('OTHER_PAYMENT_METHODS'),
  NONE: Symbol('NONE'),
};
